import styled from 'styled-components';

export const Wrapper = styled.div<{ $disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-width: 260px;
  max-width: 268px;
  padding: 16px;
  gap: 16px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.black4};
  background: ${({ theme, $disabled }) => ($disabled ? theme.colors.black1 : theme.colors.white)};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  :hover {
    background: ${({ theme }) => theme.colors.black1};
  }
`;

export const IconWrapper = styled.div<{ $disabled?: boolean }>`
  font-size: 40px;
  font-weight: 600;
  letter-spacing: -0.5px;
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
`;

export const TitleWrapper = styled.span<{ $disabled?: boolean }>`
  color: ${({ theme, $disabled }) => ($disabled ? theme.colors.black6 : theme.colors.black9)};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
`;

export const DescriptionWrapper = styled.span<{ $disabled?: boolean }>`
  overflow: hidden;
  color: ${({ theme, $disabled }) => ($disabled ? theme.colors.black6 : theme.colors.black7)};
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;
